import {createStateMaker} from '@shared/helpers/object'

import {CashReceiptIssueType, CashReceiptIssueUsage} from '@web/core/constants'

import {CashReceiptState} from '../interfaces'
import {isValidIssueNumber} from '../utils/cashReceipt'

export const getInitialState = (): CashReceiptState => ({
    available: true,
    issueNumber: {
        /** 휴대폰번호 */
        [CashReceiptIssueType.PR_CELL_PHONE_NUMBER]: ['010', '', ''],
        /** 현금 영수증 카드 번호 */
        [CashReceiptIssueType.PR_CASH_RECEIPT_CARD_NUMBER]: ['', '', '', ''],
        /** 사업자 등록번호 */
        [CashReceiptIssueType.BUSINESS_REGISTRATION_NUMBER]: ['', '', ''],
    },
    issueType: {
        current: CashReceiptIssueType.PR_CELL_PHONE_NUMBER,
        prev: CashReceiptIssueType.PR_CELL_PHONE_NUMBER,
        saved: null,
    },
    /** 현금영수증 저장 여부 */
    shouldBeSaved: false,
    /** 현금영수증정보 수정중 여부 */
    isEdit: false,
    prevUsageType: CashReceiptIssueUsage.PERSONAL_INCOME_TAX,
    receiptPolicy: [],
    availableIssueTypes: [
        CashReceiptIssueType.PR_CELL_PHONE_NUMBER,
        CashReceiptIssueType.PR_CASH_RECEIPT_CARD_NUMBER,
        CashReceiptIssueType.BUSINESS_REGISTRATION_NUMBER,
    ],
    issuer: 'NORMAL',
})

export const makeMock = createStateMaker<CashReceiptState>(getInitialState)

export const validateIssueNumber = ({issueType, issueNumber}: Pick<CashReceiptState, 'issueType' | 'issueNumber'>) => {
    const {current} = issueType

    switch (current) {
        case CashReceiptIssueType.BUSINESS_REGISTRATION_NUMBER:
        case CashReceiptIssueType.PR_CASH_RECEIPT_CARD_NUMBER:
        case CashReceiptIssueType.PR_CELL_PHONE_NUMBER: {
            return isValidIssueNumber({issueType: current, issueNumber: issueNumber[current]})
        }
        default: {
            return false
        }
    }
}

export const createIssueNumberStr = ({issueType, issueNumber}: Pick<CashReceiptState, 'issueType' | 'issueNumber'>) => {
    const {current} = issueType

    if (current && current in issueNumber) {
        const target = issueNumber[current as keyof typeof issueNumber]

        return target.join('-')
    }

    return ''
}
